import { useNavigate, useSearch } from '@tanstack/react-location'
import React, { useEffect } from 'react'
import Loader from 'shared/components/Loader'
import { getUnitByUnitId, getVideosByUnitTypeId } from 'IFrameApp/services/tour.service'
import { getUnitByUnitNumber } from 'shared/services/tour.service'
import { useStore } from 'TourApp/store'
import { hasVideos, isGalleryAvailable, isProductionBuild } from 'shared/helpers/general'
import { logDevelopment } from 'shared/helpers/log'
import { getUserById } from 'shared/services/user.service'
import { upsertApartmentPageInvitation } from 'CRM/services/invites'

function ApartmentFetcher() {
  const {
    unitId,
    unit_number,
    property_name,
    skipAnalytics,
    agent_id,
    hide_unit,
    source,
    line_app,
    person,
    skip_cache,
    building_name,
    invitation_id
  } = useSearch()
  const { tourData, setTourData, setSelectedApartmentId, setSkipAnalytics, setHideUnit, setSource, setIsLineApp } =
    useStore()
  const navigate = useNavigate()

  useEffect(() => {
    async function fetchData() {
      if (!tourData) {
        let unit
        setSkipAnalytics(!!skipAnalytics)
        if (source) {
          setSource(source, skip_cache)
        }
        if (line_app) {
          setIsLineApp(true, skip_cache)
        }
        //==========================================================================
        // Fetch unit by unitId
        //==========================================================================
        if (unitId || (!isProductionBuild() && !unit_number && !property_name)) {
          const searchUnitId = !isProductionBuild()
            ? Number(atob(unitId)) || +localStorage.getItem('devUnitId') || 1
            : Number(atob(unitId))
          logDevelopment(`Fetching unit by unit id ${searchUnitId}`)
          const unitResponse = await getUnitByUnitId(searchUnitId)
          unit = unitResponse.data.units_by_id
        }
        //==========================================================================
        // Fetch unit by unit number and property name
        //==========================================================================
        if (unit_number && property_name) {
          logDevelopment(`Fetching unit by number ${unit_number} and property ${property_name}`)
          const unitResponse = await getUnitByUnitNumber(String(unit_number), property_name)
          const units = unitResponse.data.units_by_unit_number
          const filtered = building_name ? units.filter((item) => item.building_name === building_name) : units
          unit = filtered.find((item) => item.unit_type.ready_for_publish) || filtered[0]
        }
        const videosResponse = await getVideosByUnitTypeId(unit.unit_type.id)
        const videos = videosResponse.data.videos_by_unit_type_id

        let agent

        if (agent_id) {
          const { data } = await getUserById(Number(agent_id))
          agent = data.user_by_id
        }

        if (hide_unit) {
          setHideUnit(Boolean(hide_unit))
        }

        //==========================================================================
        // Send invitation when all data is fetched
        //==========================================================================
        if(invitation_id){
          try {
            await upsertApartmentPageInvitation(invitation_id, window.location.href, 'accepted')
          } catch (error) {
            console.error(`Error updating invitation ${invitation_id}`, error)
          }
        }

        setTourData(
          JSON.parse(
            JSON.stringify({
              liked_assets: [],
              app_user_first_name: person,
              personalized: !!person,
              agent,
              units: [
                {
                  unit: {
                    ...unit,
                    unit_type: {
                      ...unit.unit_type,
                      videos,
                    },
                  },
                },
              ],
            }),
          ),
          skip_cache,
        )
        setSelectedApartmentId(unit.id, skip_cache)
      }
    }
    fetchData()
  }, [tourData])

  useEffect(() => {
    if (tourData) {
      if(isGalleryAvailable(tourData)){
        navigate({ to: '/gallery' })
        return
      }
      if(hasVideos(tourData.units[0].unit)){
        navigate({ to: '/videos' })
        return
      }
      alert("Error, please try again later.")
    }
  }, [tourData, navigate])

  return (
    <div className="h-screen w-screen flex justify-center items-center">
      <Loader />
    </div>
  )
}

export default ApartmentFetcher
